import * as React from "react";

import { cn } from "@/lib/utils";

const nativeSelectClassName =
  "h-8 w-full min-w-0 truncate rounded-lg border border-transparent bg-control py-1 pl-2.5 pr-6 text-base transition-colors outline-none hover:bg-muted/70 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-60 md:text-sm [&>option]:bg-surface [&>option]:text-foreground";

type NativeSelectProps = React.ComponentPropsWithRef<"select">;

/**
 * Native <select> visually paired with the Input primitive. Long option labels
 * truncate with clearance for the native chevron.
 */
function NativeSelect({ className, ref, ...props }: NativeSelectProps) {
  return (
    <select
      ref={ref}
      data-slot="native-select"
      // Options carry explicit theme colours: the native popup only follows
      // color-scheme for its chrome, so inherited foreground text can land
      // on a mismatched popup background otherwise.
      className={cn(nativeSelectClassName, className)}
      {...props}
    />
  );
}

export { NativeSelect, nativeSelectClassName };
